<template>
  <div class="tw-w-full tw-flex tw-text-[#1F2229] tw-pt-10">
    <div class="tw-flex tw-flex-col tw-gap-10 tw-grow tw-bg-white tw-rounded-2xl">
      <PortfolioSelectWrapper />
      <BenchmarkSelectWrapper />
      <OptimizedProposedSelectWrapper />
      <AdvisorCoreOptions />
    </div>
    <!-- <AdvisorCoreInstructions /> -->
  </div>
</template>


<script>
// import SubComponent from '../components/SubComponent'
import PortfolioSelectWrapper from '@frontend/ui/features/checkup/components/portfolio-select/PortfolioSelectWrapper.vue';
import BenchmarkSelectWrapper from '@frontend/ui/features/checkup/components/portfolio-select/BenchmarkSelectWrapper.vue';
import OptimizedProposedSelectWrapper from '@frontend/ui/features/checkup/components/portfolio-select/OptimizedProposedSelectWrapper.vue';
import AdvisorCoreOptions from '@frontend/ui/features/checkup/components/portfolio-select/AdvisorCoreOptions.vue';
import RunAnalysisButton from '@frontend/ui/features/checkup/components/portfolio-select/RunAnalysisButton.vue';
import AdvisorCoreInstructions from '@frontend/ui/features/checkup/components/portfolio-select/AdvisorCoreInstructions.vue';
import { mapStores } from 'pinia';
import { useCheckupStore } from '@frontend/ui/stores/checkupStore';

export default {
  name: 'AdvisorCoreStart',
  components: {
    PortfolioSelectWrapper,
    BenchmarkSelectWrapper,
    OptimizedProposedSelectWrapper,
    AdvisorCoreOptions,
    RunAnalysisButton,
    AdvisorCoreInstructions,
  },
  props: {
    // prop: { type: String, required: true },
    // prop: String,
  },
  data() {
    return { /* Local variables */ };
  },
  computed: {
    ...mapStores(useCheckupStore),

  },
  watch: { /*
    Watches an existing property
    Only runs when the watched property changes */

    // Cannot put a watcher in the pinia store
    // This seems like the most logical place to put it
    'checkupStore.selectedPortfolios': function() {
      if (!this.areUploadsInProgress()) {
        this.checkupStore.updateHoldingsByPortfolio();
      } else {
        console.log('Uploads are still in progress. Skipping update.');
      }
    },
  },
  beforeCreate() {},
  created() {},
  mounted() {},
  updated() {},
  methods: {
    areUploadsInProgress() {
    // Log the current state of files and their upload statuses
      console.log('Checking if uploads are in progress...');
      if (this.checkupStore?.files) {
        this.checkupStore.files.forEach((file, index) => {
          console.log(`File ${index + 1}:`, file);
          console.log(`Upload Status: ${file.uploadStatus}`);
        });

        const uploadsInProgress = this.checkupStore.files.some(file => file.uploadStatus === 'uploadStarted');
        console.log('Uploads in progress:', uploadsInProgress);
        return uploadsInProgress;
      } else {
        console.log('No files found in checkupStore.');
        return false;
      }
    },
    clearPortfolioNotifications() {
      const keysToRemove = [
        'NO_MATCHED_HOLDINGS_PORTFOLIO',
        'MISSING_TICKER_SYMBOLS_NON_UPLOAD',
        'MISSING_TICKER_SYMBOLS',
        'NO_MATCHED_HOLDINGS',
      ];

      keysToRemove.forEach(key => {
        if (this.activeNotifications[key]) {
          delete this.activeNotifications[key];
        }
      });
      console.log('new active notifications', this.activeNotifications);
    },
  },
};
</script>


<style scoped>

</style>
